<template>
  <div class="page">
    <div class="app-container">
      <BaseSearch
        v-model="searchData"
        :formOptions="searchFormOption"
        @handleSearch="handleSearch"
      >
      </BaseSearch>
      <el-button type="primary" @click="add">新增退统</el-button>

      <BaseTable
        ref="baseTable"
        url="admin/returnbill/index"
        :tableData.sync="tableData"
        :searchParams="searchData"
        :columns="columns"
        :paramsCepCallback="paramsCepCallback"
      >
        <template #custom="{ scope }">
          {{ scope.row.title }}
        </template>
        <template #handle="{ row }">
          <el-button type="text" size="mini" @click="detail(row)"
            >详情</el-button
          >
          <el-button
            v-if="row.status === 0"
            type="text"
            size="mini"
            @click="del()"
            >删除</el-button
          >
          <el-button
            type="text"
            v-if="row.status === 0"
            size="mini"
            @click="examineEdit(row)"
            >审核</el-button
          >
          <el-button
            type="text"
            v-if="row.status === 1"
            size="mini"
            @click="financeEdit(row)"
            >财务确认</el-button
          >
          <el-button
            type="text"
            v-if="row.status === 3"
            size="mini"
            @click="actualEdit(row)"
            >修改实退</el-button
          >
        </template>
      </BaseTable>

      <!-- 退统修改实退 -->
      <el-dialog title="退统修改实退" :visible.sync="isShowDialog" width="30%">
        <el-form labelWidth="100px" size="medium">
          <el-form-item label="服务单号：">
            {{ actualFormData.insBillId }}
          </el-form-item>
          <el-form-item label="实退费用：">
            <el-input
              type="number"
              v-model="actualFormData.actual_cost"
              required
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isShowDialog = false">取 消</el-button>
          <el-button type="primary" @click="onActualSubmit">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 退统审核 -->
      <el-dialog
        title="退统审核"
        :visible.sync="isShowExamineDialog"
        width="30%"
      >
        <el-form labelWidth="100px" size="medium">
          <el-form-item label="服务单号：">
            {{ examineFormData.insBillId }}
          </el-form-item>
          <el-form-item label="审核结果：">
            <el-radio-group v-model="examineFormData.state">
              <el-radio :label="1">审核通过</el-radio>
              <el-radio :label="2">审核不通过</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="实退费用：">
            <el-input
              type="textarea"
              v-model="examineFormData.remark"
              required
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isShowExamineDialog = false">取 消</el-button>
          <el-button type="primary" @click="onExamineSubmit">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 财务确认 -->
      <el-dialog
        title="退统财务确认"
        :visible.sync="isShowFinanceDialog"
        width="30%"
      >
        <el-form labelWidth="150px" size="medium">
          <el-form-item label="服务单号：">
            <el-input
              type="number"
              v-model="financeFormData.insBillId"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="退款费用：">
            <el-input
              type="number"
              v-model="financeFormData.cost"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="实退金额：">
            <el-input
              type="number"
              v-model="financeFormData.actual_cost"
              required
            ></el-input>
          </el-form-item>
          <el-form-item label="实际支付时间：">
            <el-date-picker
              v-model="financeFormData.deliver_time"
              align="right"
              type="datetime"
              placeholder="实际支付时间"
              required
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isShowFinanceDialog = false">取 消</el-button>
          <el-button type="primary" @click="onFinanceSubmit">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 退统新增/详情 -->
      <el-drawer title="退统" :visible.sync="isShowDrawer" direction="rtl">
        <div style="padding: 40px">
          <div style="flex"></div>
          <el-form labelWidth="100px" size="medium">
            <el-form-item label="查询：" v-show="isEdit">
              <el-input
                placeholder="请输入服务单流水号/车牌号"
                v-model="formData.insBillId"
              >
                <template slot="append"
                  ><i class="el-icon-search" @click="handleSearchDetail"></i
                ></template>
              </el-input>
            </el-form-item>

            <el-form-item label="服务单号：">
              {{ billData.bh }}
            </el-form-item>
            <el-form-item label="服务起期：">
              {{ billData.beginTime }}
            </el-form-item>
            <el-form-item label="服务止期：">
              {{ billData.endTime }}
            </el-form-item>
            <el-form-item label="业务员：">
              {{ billData.realname }}
            </el-form-item>
            <el-form-item label="发票号码：">
              {{ billData.fp_number }}
            </el-form-item>
            <el-form-item label="应交服务费：">
              {{ billData.cusFee }}
            </el-form-item>
            <el-form-item label="净费：">
              {{ billData.netFee }}
            </el-form-item>
            <div class="line"></div>
            <!-- <el-form-item label="是否全款：">
                        <el-radio-group v-model="radio">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item> -->
            <el-form-item label="退统日期：">
              <el-date-picker
                v-model="formData.return_date"
                align="right"
                type="date"
                placeholder="选择日期"
                @change="handleReturnDate"
                :disabled="disabled"
                required
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="退统费用：">
              <el-input
                type="number"
                v-model="formData.cost"
                :disabled="disabled"
                required
              ></el-input>
            </el-form-item>
            <el-form-item label="退统天数：">
              <el-input
                type="number"
                v-model="formData.days"
                :disabled="disabled"
                required
              ></el-input>
            </el-form-item>
            <el-form-item label="实退费用：">
              <el-input
                type="number"
                v-model="formData.actual_cost"
                :disabled="disabled"
                required
              ></el-input>
            </el-form-item>
            <el-form-item label="备注：">
              <el-input
                type="textarea"
                v-model="formData.apply_remark"
                :disabled="disabled"
                required
              ></el-input>
            </el-form-item>
            <div class="img-box">
              <div
                class="img-item"
                v-for="(item, index) in imgOption"
                :key="index"
              >
                <el-upload
                  class="avatar-uploader"
                  :action="$settings.uploadUrl.img + '/admin/upload/upimg'"
                  name="img"
                  :show-file-list="false"
                  :headers="{
                    token: getToken(),
                  }"
                  :data="{
                    path: 20,
                  }"
                  :on-success="(res) => uploadImgSuccess(res, item.key)"
                >
                  <img
                    v-if="formData[item.key]"
                    :src="formData[item.key]"
                    class="avatar"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>

                <div class="img-title">{{ item.title }}</div>
              </div>
            </div>

            <el-button
              style="margin-top: 50px"
              type="primary"
              @click="onSubmit"
              v-if="isEdit"
              >保存</el-button
            >
          </el-form>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { searchFormOption } from "./formOptions";
import { columns } from "./columns";
import { getToken } from "@/utils/auth";
import { rules } from "./rules";
export default {
  name: "Refund",
  comments: {},
  data() {
    return {
      tableData: [],
      searchData: {},
      billData: {},
      formData: {
        insBillId: "",
        bank_img: "",
        card_img: "",
        apply_img: "",
        cost: 0,
        return_date: "",
        days: 0,
        actual_cost: 0,
      },
      actualFormData: {
        insBillId: "",
        actual_cost: 0,
      },
      examineFormData: {
        insBillId: "",
        state: 1,
        remark: "",
      },
      financeFormData: {
        insBillId: "",
        cost: 0,
        actual_cost: 0,
        deliver_time: "",
      },
      orgOption: [],
      // 是否显示新增/详情弹框
      isShowDrawer: false,
      // 是否显示修改实退弹窗
      isShowDialog: false,
      // 是否显示审核弹窗
      isShowExamineDialog: false,
      // 是否显示退统财务确认
      isShowFinanceDialog: false,
      // 是否为编辑
      isEdit: true,
      // 新增编辑页面是否禁用
      disabled: false,
      imgOption: [
        {
          key: "bank_img",
          title: "银行卡图片",
        },
        {
          key: "card_img",
          title: "身份证照片",
        },
        {
          key: "apply_img",
          title: "申请批改书",
        },
      ],
    };
  },
  computed: {
    columns,
    searchFormOption,
    rules,
  },
  created() {
    this.getOrg();
  },
  methods: {
    getToken,
    getOrg() {
      this.$api.post("/admin/org/index", {}).then((res) => {
        this.orgOption = res?.data?.data;
      });
    },
    // 打开新增退统弹窗
    add() {
      this.formData = {
        insBillId: "",
        bank_img: "",
        card_img: "",
        apply_img: "",
        cost: 0,
        return_date: "",
        days: 0,
        actual_cost: 0,
      };
      this.billData = {};
      this.disabled = true;
      this.isShowDrawer = true;
      this.isEdit = true;
    },
    // 打开退统详情
    detail(row) {
      this.billData = {
        insBillId: row.insBillId,
        beginTime: row.beginTime,
        endTime: row.endTime,
        realname: row.realname,
        fp_number: row.fp_number,
        cusFee: row.cusFee,
        netFee: row.netFee,
      };

      this.formData = {
        insBillId: row.insBillId,
        bank_img: row.bank_img,
        card_img: row.card_img,
        apply_img: row.apply_img,
		apply_remark: row.apply_remark,
        cost: row.cost,
        return_date: row.return_date,
        days: row.days,
        actual_cost: row.actual_cost,
      };
      this.isShowDrawer = true;
      this.disabled = true;
      this.isEdit = false;
    },
    // 打开修改实退弹框
    actualEdit(row) {
      this.actualFormData.insBillId = row.insBillId;
      this.actualFormData.actual_cost = row.actual_cost;
      this.isShowDialog = true;
    },
    // 打开退统审核弹窗
    examineEdit(row) {
      this.examineFormData.insBillId = row.insBillId;
      this.isShowExamineDialog = true;
    },
    financeEdit(row) {
      this.financeFormData.insBillId = row.insBillId;
      this.financeFormData.actual_cost = row.actual_cost;
      console.log(row.cost);
      this.financeFormData.cost = row.cost;
      this.financeFormData.deliver_time = this.getTime();
      this.isShowFinanceDialog = true;
    },
    // 删除退统
    del({ id }) {
      this.$confirm("是否确认删除该退统信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.$api.post("/admin/returnbill/del", { id }, "删除");
          this.handleSearch();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 新增退统
    onSubmit() {
      if (!this.billData.beginTime) {
        this.$message({
          message: "请选择服务单",
          type: "error",
        });
        return;
      }
      let keys = Object.keys(this.rules);
      for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        if (!this.formData[key]) {
          this.$message({
            message: this.rules[key].message,
            type: "error",
          });
          return;
        }
      }

      this.$api
        .post("admin/returnbill/save", this.formData, "退统")
        .then(() => {
          this.isShowDrawer = false;
        });
    },

    // 提交退统实退修改
    onActualSubmit() {
      this.$api
        .post(
          "admin/returnbill/editRealReturnFee",
          this.actualFormData,
          "修改实退"
        )
        .then(() => {
          this.isShowDialog = false;
          this.handleSearch();
        });
    },
    // 提交退统财务确认
    onFinanceSubmit() {
      this.$api
        .post(
          "admin/returnbill/financeExamine",
          this.financeFormData,
          "退统财务确认"
        )
        .then(() => {
          this.isShowFinanceDialog = false;
          this.handleSearch();
        });
    },
    // 提交退统实退修改
    onExamineSubmit() {
      if (!this.examineFormData.state) {
        this.$message({
          message: "请选择审核状态",
          type: "error",
        });
        return;
      }
      this.$api
        .post("admin/returnbill/examine", this.examineFormData, "退统审核")
        .then(() => {
          this.isShowExamineDialog = false;
          this.handleSearch();
        });
    },

    // 查询服务单详情
    handleSearchDetail() {
      this.$api
        .post("admin/returnbill/getBillDetail", {
          insBillId: this.formData.insBillId,
        })
        .then((res) => {
          this.disabled = false;
          this.billData = res.data;
        });
    },
    // 自动计算退统金额
    handleReturnDate(e) {
      let date = e;
      let { beginTime, endTime, netFee, cusFee } = this.billData;
      let endDate = new Date(endTime);
      let beginDate = new Date(beginTime);

      // 服务天数
      let allDays = this.$tools.getDaysBetween(beginTime, endTime);
      // 退统天数
      let returnDays = this.$tools.getDaysBetween(date, endTime);
      if (date > endDate) {
        returnDays = 0;
      }
      if (date < beginDate) {
        returnDays = this.$tools.getDaysBetween(beginTime, endTime);
      }

      // 获取一天的钱数
      const dayMoney = cusFee / allDays;
      // 退服务钱数
      const cost = (returnDays * dayMoney).toFixed(2);

      this.$nextTick(() => {
        this.formData.cost = cost;
        this.formData.days = returnDays;
        this.formData.actual_cost = cost;
      });
    },
    handleSearch() {
      this.$refs.baseTable.searchData(1);
    },
    // 上传图片成功后
    uploadImgSuccess(res, key) {
      this.formData[key] = res.data.path;
      console.log(this.formData);
    },

    getTime() {
      var date = new Date(); //当前时间
      var month = this.zeroFill(date.getMonth() + 1); //月
      var day = this.zeroFill(date.getDate()); //日
      var hour = this.zeroFill(date.getHours()); //时
      var minute = this.zeroFill(date.getMinutes()); //分
      var second = this.zeroFill(date.getSeconds()); //秒

      //当前时间
      var curTime =
        date.getFullYear() +
        "-" +
        month +
        "-" +
        day +
        " " +
        hour +
        ":" +
        minute +
        ":" +
        second;

      return curTime;
    },

    zeroFill(i) {
      if (i >= 0 && i <= 9) {
        return "0" + i;
      } else {
        return i;
      }
    },

    // 搜索参数拦截
    paramsCepCallback(params) {
      console.log(params);
      return {
        ...params,
        ...this.searchData,
      };
    },
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.img-box {
  display: flex;
}

.img-item {
  width: 33.33333%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
